<template>
  <div id="home" v-wechat-title="this.title">
    <div class="content"></div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        title:'林云隆嘉',
        theme1: 'light',
      }
    },
    mounted(){
      setTimeout(() => {
        this.$LoadingBar.finish();
      }, 500);
    },
  }
</script>

<style scoped>
  #home{
    width: 100%;
    height: auto;
    overflow: hidden;
  }
  .content{
    width: 100%;
    height: 950px;
    background-image: url("/images/bg.jpg");
  }
</style>
